// Complaint handling numbers for the dashboard.

import type { PublicComplaint } from '@residenone/shared';

function monthKey(d: Date, back = 0): string {
  const x = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() - back, 1));
  return x.toISOString().slice(0, 7);
}

/** Mean hours from filed to resolved, for complaints resolved this month. Null when none were. */
export function averageResolveHours(items: PublicComplaint[], today: Date): number | null {
  const month = monthKey(today);
  const hours = items
    .filter((c) => c.status === 'RESOLVED' && c.resolved_at && c.resolved_at.slice(0, 7) === month)
    .map((c) => (Date.parse(c.resolved_at!) - Date.parse(c.created_at)) / 3_600_000);
  return hours.length ? Math.round(hours.reduce((s, h) => s + h, 0) / hours.length) : null;
}
